module.exports = __webpack_public_path__ + "static/media/student-score-star.e31abd37.png";